import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  progressBar$ = new BehaviorSubject(false);
  spinner$ = new BehaviorSubject(false);
  progress: number = 0;
  progressInterval!: any;
  public loading = new BehaviorSubject<boolean>(false);

  constructor() { }

  startProgressBar() {
    setTimeout(() => {
      // Com pedidos HTTP concorrentes, o handle partilhado era sobrescrito
      // sem clear e o interval antigo corria para sempre — cada um forçava um
      // ciclo global de change detection a cada 100ms, acumulando por pedido
      // até saturar o event loop e congelar o browser.
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
      this.progress = 0;
      this.progressBar$.next(true);
      this.setLoading(true);
      this.progressInterval = setInterval(() => {
        if (this.progress < 75) {
          this.progress += 20;
        } else {
          // Auto-terminação: chegado aos 75% o progresso já não muda; parar o
          // interval garante vida máxima de ~500ms mesmo se um clear se perder.
          clearInterval(this.progressInterval);
          this.progressInterval = null;
        }
      }, 100);
    });
  }

  stopProgressBar() {
    setTimeout(() => {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
      this.progress += (100 - this.progress);
      setTimeout(() => {
        this.progressBar$.next(false);
        this.setLoading(false);
      }, 600);
    }, 100);
  }

  startSpinner() {
    this.spinner$.next(true);
  }

  stopSpinner() {
    this.spinner$.next(false);
  }

  setLoading(isLoading: boolean) {
    this.loading.next(isLoading);
  }
}